import { animate, stagger, inView } from "motion";
import Atropos from "atropos";
import "atropos/css";

// Funkcja inicjalizująca Atropos na elemencie
const initializeAtropos = (item) => {
  Atropos({
    el: item,
    rotate: true,
    rotateXMax: 15,
    rotateYMax: 15,
    shadow: false,
    highlight: true,
    duration: 300,
    activeOffset: 50,
    shadowOffset: 50,
    shadowScale: 1,
  });
};

// Inicjalizacja animacji szerokości i Atropos, gdy element stanie się widoczny
inView(
  ".portfolio__item-cover",
  ({ target }) => {
    // Animacja szerokości
    animate(
      target,
      { width: ["100%", "0%"] },
      { delay: stagger(0.4), duration: 0.6 }
    );
  },
  {
    margin: "-200px 0px",
  }
);

document.querySelectorAll(".portfolio__grid-item").forEach((item) => {
  let isHovered = false;

  item.addEventListener("mouseenter", () => {
    if (!isHovered) {
      isHovered = true;
      const cover = item.querySelector(".portfolio__item-cover");
      const content = item.querySelector(".portfolio__grid-content");

      // Animacja szerokości i opacity dla cover
      animate(
        cover,
        { width: ["0%", "100%"], opacity: [0, 0.4] },
        { duration: 0.4 }
      );

      // Animacja dla content
      animate(
        content,
        { opacity: [0, 1], bottom: ["-200px", "2rem"] },
        { duration: 0.6 }
      );
    }
  });

  item.addEventListener("mouseleave", () => {
    if (isHovered) {
      isHovered = false;
      const cover = item.querySelector(".portfolio__item-cover");
      const content = item.querySelector(".portfolio__grid-content");

      // Powrót animacji szerokości i opacity dla cover
      animate(
        cover,
        { width: ["100%", "0%"], opacity: [0.4, 0] },
        { duration: 0.4 }
      );

      // Powrót animacji dla content
      animate(
        content,
        { opacity: [1, 0], bottom: ["2rem", "-200px"] },
        { duration: 0.6 }
      );
    }
  });
});
